@if (page$ | async; as page) {
    <div class="main">
        @if (filter$ | async; as filter) {
            <div class="filter-toolbar">
                <redispatch-netzbetreiber-filter
                    [initialFilter]="filter"
                    (filter)="filterChanged($event)"
                ></redispatch-netzbetreiber-filter>
            </div>
            <div>
                <div style="overflow: auto;" data-qa="redispatch-netzbetreiber-table">
                    <table
                        mat-table
                        [dataSource]="netzbetreiberList"
                        class="netzbetreiber-table"
                        matSort
                        [matSortDirection]="page.direction"
                        [matSortActive]="page.sort"
                        (matSortChange)="sortChange($event)">
                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                        <tr style="cursor: pointer" mat-row *matRowDef="let netzbetreiber; columns: columnsToDisplay"
                            [routerLink]="routingService.netzbetreiberPath"
                            [queryParams]="{stadtwerkeId: netzbetreiber.stadtwerkeId, openedInSideNav: true}"
                            queryParamsHandling="merge" data-qa="tnb-netzbetreiber-row"></tr>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="name">Name</th>
                            <td mat-cell *matCellDef="let netzbetreiber;" data-qa="name">{{ netzbetreiber.name }}</td>
                        </ng-container>
                        <ng-container matColumnDef="teilgebiet">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="teilgebiet">Teilgebiet</th>
                            <td mat-cell *matCellDef="let netzbetreiber;"
                                data-qa="teilgebiet">{{ netzbetreiber.teilgebiet }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="netzbetreibernummer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="netzbetreibernummer">
                                Netzbetreibernummer
                            </th>
                            <td mat-cell *matCellDef="let netzbetreiber;"
                                data-qa="netzbetreibernummer">{{ netzbetreiber.netzbetreibernummer }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="stadtwerkeId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="stadtwerkeId">Stadtwerke-ID
                            </th>
                            <td mat-cell *matCellDef="let netzbetreiber;"
                                data-qa="stadtwerkeId">{{ netzbetreiber.stadtwerkeId }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="geschaeftspartnerId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="geschaeftspartnerId">
                                Geschäftspartner-ID
                            </th>
                            <td mat-cell *matCellDef="let netzbetreiber;"
                                data-qa="geschaeftspartnerId">{{ netzbetreiber.geschaeftspartnerId }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="lastImportDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="lastImportDate">Letzte
                                Aktualisierung (Erzeugerdaten)
                            </th>
                            <td mat-cell *matCellDef="let netzbetreiber;" class="no-wrap" data-qa="lastImportDate">
                                @if (!!netzbetreiber.lastImportDate) {
                                    <span>{{ netzbetreiber.lastImportDate | date: 'dd.MM.yyyy' }}</span>
                                }
                                @if (!netzbetreiber.lastImportDate) {
                                    <span>-</span>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="dienstleistungsart">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="dienstleistungsart">
                                Dienstleistungsart
                            </th>
                            <td mat-cell *matCellDef="let netzbetreiber;" data-qa="dienstleistungsart">
                                @if (netzbetreiber.dienstleistungsart) {
                                    <span>{{ netzbetreiber.dienstleistungsart.title }}</span>
                                }
                                @if (!netzbetreiber.dienstleistungsart) {
                                    <span>-</span>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="dienstleistungsmoduleBeschreibung">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="dienstleistungsmodule">Anz.
                                Dienstleistungsmodule
                            </th>
                            <td mat-cell *matCellDef="let netzbetreiber;" class="no-wrap"
                                data-qa="dienstleistungsmodule">
                                <span>{{ netzbetreiber.dienstleistungsmoduleBeschreibung.length }}</span>
                                <div class="menu-container" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                                     [matMenuTriggerRestoreFocus]="true">
                                    <mat-icon svgIcon="innogy_picto_speech-bubble_exclamationmark"
                                              (mouseenter)="menuTrigger.openMenu(); menuTrigger.focus()"
                                              (mouseleave)="menuTrigger.closeMenu()">
                                    </mat-icon>
                                </div>
                                <mat-menu #menu="matMenu" [hasBackdrop]="false" class="no-max-width show-active">
                                    @for (module of netzbetreiber.dienstleistungsmoduleBeschreibung; track module.id) {
                                        <span mat-menu-item disabled>
                      {{ module.title }}
                    </span>
                                    }
                                    @if (netzbetreiber.dienstleistungsmoduleBeschreibung.length === 0) {
                                        <span mat-menu-item disabled>
                      Keine Dienstleistungsmodule ausgewählt
                    </span>
                                    }
                                </mat-menu>
                            </td>
                        </ng-container>
                    </table>
                </div>
                <mat-paginator #paginator
                               [showFirstLastButtons]="false"
                               [hidePageSize]="true"
                               [pageSize]="PAGE_SIZE"
                               [pageIndex]="page.page"
                               [length]="netzbetreiberList.filteredData.length"
                               (page)="pageChange($event)">
                </mat-paginator>
            </div>
        }
    </div>
}
